<style scoped>
/* stripping styles */
body,
a,
p,
h3,
ul,
li {
	margin: 0;
	padding: 0;
	text-decoration: none;
	list-style: none;
}

li {
	list-style: none;
}
a {
	text-decoration: none;
}

.signature-container {
	display: flex;
	flex-direction: column;
}

.override-for,
.date-container {
	display: flex;
	align-items: center;
	margin-right: 20px;
}

input[type="checkbox"],
input[type="radio"] {
	position: static;
	cursor: pointer;
	width: 15px;
	height: 15px;
	opacity: 1;
	margin-right: 5px;
}

.checkbox-container,
.radio-container {
	margin-right: 5px;
}

.new-deadline {
	margin-left: 50px;
}
</style>

<template lang="html">
	<div>
		<h3>Article Overrides</h3>

		<!-- Provide a checkbox list to enable and disable the various overrides -->
		<ul class="checkbox-container">
			<li v-for="(override, overrideIndex) of overrides">
				<input
					type="checkbox"
					:id="override.key"
					:checked="enabledOverrides.indexOf(override.id) != -1"
					name=""
					value=""
					@click="toggleOverride(override)"
				/>
				<label class="" @click="toggleOverride(override)">{{
					override.name
				}}</label>
			</li>
		</ul>

		<button v-if="!saving" @click="saveOverrides()">Save</button>

		<span
			v-if="saving"
			aria-hidden="true"
			class="icon fas fa-spinner fa-spin"
		/>

		<p
			:style="{
				color: saveMessageColor,
			}"
		>
			{{ saveMessage }}
		</p>
	</div>
</template>

<script>
export default {
	props: ["articleId"],
	data() {
		return {
			saving: false,
			overrides: [],
			saveMessage: "",
			enabledOverrides: [],
			saveMessageColor: "green",
		}
	},
	methods: {
		getOverrides: async function() {
			try {
				// Fetches the the available types of overrides,
				// and grabs our currently enabled overrides for this specific article
				;[this.overrides, this.enabledOverrides] = [
					(await axios.get(`/api/articles/overrideTypes`)).data,
					(await axios.get(
						`/api/articles/${this.articleId}/overrides`
					)).data,
				]

				this.$forceUpdate()
			} catch (error) {
				//
			}
		},
		saveOverrides: async function() {
			try {
				this.saving = true

				let results = (await axios.post(
					`/api/articles/${this.articleId}/overrides`,
					{ data: this.enabledOverrides }
				)).data

				this.saveMessageColor = "green"
                this.saveMessage = "Overrides saved successfully."

				setTimeout(() => {
					this.saveMessage = ""
				}, 3000)
			} catch (e) {
				//
				this.saveMessageColor = "red"
				this.saveMessage = "There was an error saving the overrides."
			}

			this.saving = false
		},
		toggleOverride: function(override) {
			let index = this.enabledOverrides.findIndex((enabledOverride) => {
				return enabledOverride == override.id
			})

			if (index == -1) {
				this.enabledOverrides.push(override.id)
			} else {
				this.enabledOverrides.splice(index, 1)
			}

			this.$forceUpdate()
		},
	},
	created() {
		this.getOverrides()
	},
}
</script>
